.root {
  --chats-surface: var(--color-background);
  --chats-highlight: var(--color-chat-hover);
  --chats-primary-text: var(--color-text);
  --chats-secondary-text: var(--color-text-secondary);
  --chats-divider: var(--color-borders);
  --chats-accent: var(--color-primary);
  --chats-avatar-tone-blue: #5b8def;
  --chats-avatar-tone-rose: #c76891;
  --chats-avatar-tone-green: #5c9a78;
  --chats-avatar-tone-orange: #cf8652;
  --chats-avatar-tone-purple: #8571c9;
  --chats-avatar-tone-teal: #4c989c;
  --chats-header-height: 2.75rem;
  --chats-search-region-height: 3.375rem;
  --chats-page-inset: 1rem;
  --chats-row-height: 4.75rem;
  --chats-avatar-size: 3.75rem;
  --chats-avatar-gap: 0.75rem;
  --chats-header-title-size: 1.0625rem;
  --chats-row-title-size: 1rem;
  --chats-search-size: 1.0625rem;
  --chats-preview-size: 0.9375rem;
  --chats-timestamp-size: 0.875rem;
  --chats-badge-size: 1.25rem;

  display: flex;
  flex-direction: column;

  width: 100%;
  height: 100%;

  color: var(--chats-primary-text);
  background: var(--chats-surface);
  font-family: -apple-system, BlinkMacSystemFont, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", sans-serif;
}

.header {
  position: relative;

  flex: 0 0 auto;

  height: calc(var(--chats-header-height) + var(--tg-safe-area-top));
  background: var(--chats-surface);
}

.title {
  position: absolute;
  top: calc(var(--tg-safe-area-top) + 0.75rem);
  left: 50%;
  transform: translateX(-50%);

  overflow: hidden;

  max-width: 12rem;
  margin: 0;

  font-size: var(--chats-header-title-size);
  font-weight: var(--font-weight-semibold);
  line-height: 1.25rem;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.editButton,
.iconButton {
  position: absolute;
  top: var(--tg-safe-area-top);

  display: flex;
  align-items: center;
  justify-content: center;

  height: var(--chats-header-height);
  margin: 0;
  padding: 0;
  border: 0;

  color: var(--chats-accent);
  background: transparent;
  font: inherit;
  font-size: 1.0625rem;
  font-weight: var(--font-weight-medium);
  line-height: 1.25rem;

  -webkit-tap-highlight-color: transparent;
}

.editButton {
  // Telegram fullscreen native capsules occupy the horizontal content-safe inset.
  left: var(--tg-safe-area-left);

  width: 3.25rem;
}

.editButtonDone {
  font-weight: var(--font-weight-semibold);
}

.rightActions {
  position: absolute;
  top: var(--tg-safe-area-top);
  right: var(--tg-safe-area-right);

  display: flex;
  height: var(--chats-header-height);
}

.iconButton {
  position: relative;
  top: auto;

  width: var(--chats-header-height);
}

.editButton:active,
.iconButton:active,
.cancelButton:active {
  opacity: 0.6;
}

.headerIcon {
  width: 1.5rem;
  height: 1.5rem;
}

.searchRegion {
  display: flex;
  flex: 0 0 auto;
  align-items: center;

  height: var(--chats-search-region-height);
  padding: 0 var(--chats-page-inset);
  background: var(--chats-surface);
}

.searchActiveRow {
  display: flex;
  align-items: center;

  width: 100%;
  min-width: 0;
}

.searchPill {
  display: flex;
  flex: 1;
  align-items: center;
  justify-content: center;

  height: 2.75rem;
  min-width: 0;
  margin: 0;
  padding: 0 0.75rem;
  border: 0;
  border-radius: 1.375rem;

  color: var(--chats-secondary-text);
  background: var(--color-background-secondary);
  font: inherit;
}

.searchIdleContent {
  display: flex;
  align-items: center;
}

.searchIcon {
  flex: 0 0 auto;

  width: 1.125rem;
  height: 1.125rem;
}

.searchPlaceholder {
  margin-left: 0.375rem;

  font-size: var(--chats-search-size);
  line-height: 1.25rem;
}

.searchInput {
  flex: 1;

  min-width: 0;
  margin-left: 0.5rem;
  padding: 0;
  border: 0;

  color: var(--chats-primary-text);
  background: transparent;
  outline: none;
  font: inherit;
  font-size: var(--chats-search-size);
  line-height: 1.25rem;
}

.clearSearchButton {
  display: flex;
  flex: 0 0 auto;
  align-items: center;
  justify-content: center;

  width: 1.75rem;
  height: 1.75rem;
  margin: 0 -0.25rem 0 0.25rem;
  padding: 0;
  border: 0;

  color: var(--chats-secondary-text);
  background: transparent;
}

.clearIcon {
  width: 1.125rem;
  height: 1.125rem;
}

.cancelButton {
  flex: 0 0 auto;

  height: 2.75rem;
  margin: 0 0 0 0.5rem;
  padding: 0;
  border: 0;

  color: var(--chats-accent);
  background: transparent;
  font: inherit;
  font-size: 1.0625rem;
}

.list {
  overflow-x: hidden;
  overflow-y: auto;
  flex: 1;

  min-height: 0;
  padding-bottom: var(--tg-safe-area-bottom);

  -webkit-overflow-scrolling: touch;
  overscroll-behavior-y: contain;
}

.rowItem {
  width: 100%;
}

.row {
  cursor: pointer;

  display: flex;
  align-items: stretch;

  width: 100%;
  min-height: var(--chats-row-height);
  margin: 0;
  padding: 0 max(var(--chats-page-inset), var(--tg-safe-area-right)) 0 max(var(--chats-page-inset), var(--tg-safe-area-left));
  border: 0;

  color: inherit;
  text-align: left;

  background: var(--chats-surface);
  outline: none;

  -webkit-tap-highlight-color: transparent;
}

.row:active,
.rowActive {
  background: var(--chats-highlight);
}

.rowEditing {
  cursor: default;
}

.selectionControl {
  display: flex;
  flex: 0 0 auto;
  align-self: center;
  align-items: center;
  justify-content: center;

  width: 1.375rem;
  height: 1.375rem;
  margin-right: 0.75rem;
  border: 0.09375rem solid var(--chats-secondary-text);
  border-radius: 50%;

  color: var(--color-white);
}

.selectionControlSelected {
  border-color: var(--chats-accent);
  background: var(--chats-accent);
}

.selectionCheckIcon {
  width: 1rem;
  height: 1rem;
}

.avatar {
  display: flex;
  flex: 0 0 auto;
  align-self: center;
  align-items: center;
  justify-content: center;

  width: var(--chats-avatar-size);
  height: var(--chats-avatar-size);
  margin-right: var(--chats-avatar-gap);
  border-radius: 50%;

  font-size: 1.375rem;
  font-weight: var(--font-weight-semibold);
  line-height: 1;
  color: var(--color-white);
}

.avatarToneBlue { background: var(--chats-avatar-tone-blue); }
.avatarToneRose { background: var(--chats-avatar-tone-rose); }
.avatarToneGreen { background: var(--chats-avatar-tone-green); }
.avatarToneOrange { background: var(--chats-avatar-tone-orange); }
.avatarTonePurple { background: var(--chats-avatar-tone-purple); }
.avatarToneTeal { background: var(--chats-avatar-tone-teal); }

.rowBody {
  position: relative;

  display: flex;
  flex: 1;
  flex-direction: column;
  justify-content: center;

  min-width: 0;
}

.rowBody::after {
  content: '';

  position: absolute;
  right: 0;
  bottom: 0;
  left: 0;

  height: 1px;
  background: var(--chats-divider);
}

.primaryLine,
.secondaryLine {
  display: flex;
  align-items: center;

  min-width: 0;
}

.primaryLine { min-height: 1.375rem; }
.secondaryLine { min-height: 1.25rem; }

.name,
.preview,
.time {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.name {
  flex: 1;

  min-width: 0;

  font-size: var(--chats-row-title-size);
  font-weight: var(--font-weight-semibold);
  line-height: 1.375rem;
}

.time {
  flex: 0 1 auto;

  max-width: 6rem;
  margin-left: 0.5rem;

  font-size: var(--chats-timestamp-size);
  line-height: 1.125rem;
  color: var(--chats-secondary-text);
}

.preview {
  flex: 1;

  min-width: 0;

  font-size: var(--chats-preview-size);
  line-height: 1.25rem;
  color: var(--chats-secondary-text);
}

.unreadBadge {
  display: flex;
  flex: 0 0 auto;
  align-items: center;
  justify-content: center;

  min-width: var(--chats-badge-size);
  height: var(--chats-badge-size);
  margin-left: 0.5rem;
  padding: 0 0.375rem;
  border-radius: 0.625rem;

  font-size: 0.75rem;
  font-weight: var(--font-weight-semibold);
  line-height: 1;
  color: var(--color-white);

  background: var(--chats-accent);
}

.emptyState,
.errorState {
  display: flex;
  flex-direction: column;
  align-items: center;

  padding: 2rem 1rem;

  color: var(--chats-secondary-text);
  text-align: center;
  font-size: 0.875rem;
}

.errorState { gap: 0.5rem; }

.stateTitle {
  color: var(--chats-primary-text);
  font-weight: var(--font-weight-semibold);
}

.stateDescription {
  white-space: pre-line;
}

.errorDetail {
  color: var(--color-text-meta);
  font-size: 0.75rem;
  overflow-wrap: anywhere;
}

.retryButton {
  padding: 0.5rem 1.25rem;
  border: 0;
  border-radius: 0.875rem;

  color: var(--color-white);
  background: var(--chats-accent);
  font: inherit;

  cursor: pointer;
}

.sheetBackdrop {
  position: absolute;
  z-index: 20;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;

  display: flex;
  align-items: flex-end;

  background: rgb(0 0 0 / 38%);
}

.sheet {
  display: flex;
  flex-direction: column;

  width: 100%;
  max-height: 78%;
  padding: 0.5rem 1rem max(1rem, var(--tg-safe-area-bottom));
  border-radius: 1rem 1rem 0 0;

  color: var(--chats-primary-text);
  background: var(--chats-surface);
}

.sheetHandle {
  align-self: center;

  width: 2.25rem;
  height: 0.3125rem;
  border-radius: 0.25rem;

  background: var(--color-text-meta);
  opacity: 0.45;
}

.sheetTitle {
  margin: 1rem 0 0.75rem;

  text-align: center;
  font-size: 1.0625rem;
  font-weight: var(--font-weight-semibold);
  line-height: 1.375rem;
}

.sheetList {
  overflow-y: auto;
}

.sheetConversation {
  display: flex;
  align-items: center;

  width: 100%;
  min-height: 4.25rem;
  margin: 0;
  padding: 0 0.25rem;
  border: 0;

  color: inherit;
  background: transparent;
  text-align: left;
}

.sheetConversation .avatar {
  width: 3rem;
  height: 3rem;
}

.sheetConversationName {
  margin-left: 0.75rem;

  font-size: 1rem;
  font-weight: var(--font-weight-medium);
}

.sheetEmpty,
.storyUnavailable {
  padding: 1rem 0 1.5rem;

  color: var(--chats-secondary-text);
  text-align: center;
  font-size: var(--chats-preview-size);
  line-height: 1.25rem;
}

.sheetCancelButton {
  min-height: 2.75rem;
  margin-top: 0.75rem;
  border: 0;
  border-radius: 0.75rem;

  color: var(--chats-accent);
  background: var(--color-background-secondary);
  font: inherit;
  font-size: 1.0625rem;
  font-weight: var(--font-weight-semibold);
}
